import { connect } from "react-redux";
import { getMinUpgradePricesGroupByCabinPerPerson } from "app/pages/Booking/Quotation/quotationSelectors";
import FlightsFilterMarketingBanner from "app/pages/Booking/Quotation/Flight/filter/FlightsFilterMarketingBanner";

const FlightsFilterMarketingBannerContainer = props => {
	return <FlightsFilterMarketingBanner {...props} />;
};
const mapStateToProps = state => {
	const minUpgradePricesByCabinPerPerson = getMinUpgradePricesGroupByCabinPerPerson(state);
	const saleCodeName = state.partner?.flightMarketingBanner?.displayConditions?.saleCodeParamName;
	return {
		flightMarketingBanner: state.partner?.flightMarketingBanner,
		minUpgradePricesByCabinPerPerson,
		saleCode: state.partnerData[saleCodeName],
		currentMerchCode: state.merchandising?.current?.code,
	};
};

export default connect(mapStateToProps)(FlightsFilterMarketingBannerContainer);
